import {initAlpine} from "./init";
import { gsap } from "gsap";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { SplitText } from "gsap/SplitText";
import { CustomEase } from "gsap/CustomEase";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import Swiper from 'swiper';


gsap.registerPlugin(ScrollTrigger, SplitText, CustomEase, ScrollSmoother);
// Define the custom easing
const customEase = CustomEase.create("custom", "M0,0 C0.46,0.06 0.55,0.95 1,1");


// Define the function to scroll to the top of the page
function scrollToTop() {
  window.scrollTo(0, 0);
}

function setupGsapHeadings() {
  // Apply SplitText to all [gsap-heading] elements immediately on page load
  const headings = document.querySelectorAll('[gsap-heading]');
  headings.forEach(heading => {
    // Split the text into lines for each heading
    heading.splitText = new SplitText(heading, { type: 'lines' });
  });

  // ScrollTrigger setup for [gsap-heading] elements
  ScrollTrigger.batch('[gsap-heading]', {
    start: "bottom bottom",  // Animation starts when the bottom of the element hits the bottom of the viewport
    onEnter: batch => {
      batch.forEach((heading, index) => {
        // Animate the lines using fromTo
        gsap.fromTo(heading.splitText.lines,
          {
            opacity: 0,
            y: 20
          },  // Starting state
          {
            opacity: 1,
            y: 0,
            stagger: 0.4,
            delay: index * 0.3,
            duration: 0.45,
            ease: customEase
          }  // Ending state
        );
      });
    },
    once: true  // Ensures the animation only happens once
  });
}

function animateGsapElements() {
  console.log('Setting up GSAP animations...');

  // Select all elements with the [gsap-mask] attribute
  const gsapMasks = document.querySelectorAll('[gsap-mask]');

  // Create a master timeline for sequential animations
  const masterTimeline = gsap.timeline({ paused: true });

  gsapMasks.forEach((mask, index) => {
    // Set the initial state for the mask
    gsap.set(mask, { scaleY: 0 });

    // Find the associated image
    const image = mask.querySelector('[gsap-image]');
    if (image) {
      gsap.set(image, { opacity: 0 });
    }

    // Create a timeline for each instance
    const instanceTimeline = gsap.timeline();

    // Animate the mask
    instanceTimeline.to(mask, {
      scaleY: 1,
      duration: 0.6,
      ease: customEase,
    });

    // Animate the associated image after the mask animation completes
    if (image) {
      instanceTimeline.to(image, {
        opacity: 1,
        y: 0,
        duration: 0.6,
        ease: customEase,
        stagger: 0.2,
      }, "+=0.1"); // Adding a small delay to ensure the image animation starts after the mask animation
    }

    // Add the instance timeline to the master timeline
    masterTimeline.add(instanceTimeline, index * 0.1); // Adjust delay between instances as needed

    // Create a ScrollTrigger for each [gsap-mask] element
    ScrollTrigger.create({
      trigger: mask,
      start: "bottom bottom", // Trigger when top of mask hits bottom of viewport
      onEnter: () => {
        console.log('Animating mask:', mask);
        masterTimeline.play();
      },
      once: true,
    });
  });

  console.log('GSAP animations setup complete.');
}


// Function to handle hover effect
function setupNavbarHover() {
  // Select the [navbar] element
  const navbar = document.querySelector('[navbar]');

  if (navbar) {
    // Add class on mouseover
    navbar.addEventListener('mouseover', () => {
      navbar.classList.add('hover-navbar');
    });

    // Remove class on mouseout
    navbar.addEventListener('mouseout', () => {
      navbar.classList.remove('hover-navbar');
    });
  }
}



// Function to initialize animations
window.heroLoader = function() {
  // Create a new GSAP Timeline
  const tl = gsap.timeline();

  // 3. Animate [gsap-stripe] element with width from 0% to 100%
  const gsapStripe = document.querySelector('[gsap-stripe]');
  if (gsapStripe) {
    tl.fromTo(gsapStripe,
      { width: '0%' },
      { width: '100%', duration: 1, ease: customEase },
      '+=0.1' // Start this animation 100ms after the previous one
    );
  }

  // 1. Animate [bg-hero] element
  const bgHero = document.querySelector('[bg-hero]');
  if (bgHero) {
    tl.fromTo(bgHero,
      { opacity: 0 },
      { opacity: 1, duration: 0.2, ease: customEase },
      0 // Start immediately
    );
  }

  // 2. Animate [navbar] element
  const navbar = document.querySelector('[navbar]');
  if (navbar) {
    tl.fromTo(navbar,
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: customEase },
      '+=0.1' // Start this animation 100ms after the previous one
    );
  }

  // 4. Animate all [hero-description] elements
  const heroDescriptions = document.querySelectorAll('[hero-description]');
  if (heroDescriptions.length > 0) {
    tl.fromTo(heroDescriptions,
      { opacity: 0 },
      { opacity: 1, duration: 0.5, ease: customEase },
      '+=0.1' // Start this animation 100ms after the previous one
    );
  }

  // 5. Animate [hero-heading] element with SplitText
  const heroHeadings = document.querySelectorAll('[hero-heading]');
  if (heroHeadings.length > 0) {
    heroHeadings.forEach(element => {
      // Split the text into lines using SplitText
      const split = new SplitText(element, { type: 'lines' });

      // Set initial state for lines
      gsap.set(split.lines, { opacity: 0, y: 20 });

      // Add the lines animation to the timeline, ensuring sequential playback
      tl.fromTo(split.lines,
        { opacity: 0, y: 20 },
        { opacity: 1, y: 0, duration: 0.3, ease: customEase, stagger: {
            amount: 0.6, // Total duration for staggered animation
            each: 0.6, // Delay between lines to ensure sequential play
          }},
        '+=0.1' // Start this animation 100ms after the previous one
      );

      // Store SplitText instance for later use
      element._splitTextInstance = split;
    });
  }
};


window.portfolioBody = function() {

}

window.horizontalScroller = function(e) {
  var swiper = new Swiper(".swiper", {
    slidesPerView: 1, // Dynamically adjust slide width
    centeredSlides: true, // Center the active slide in the viewport
    spaceBetween: 30, // Adjust spacing between slides
    navigation: {
      nextEl: '.button-next',
      prevEl: '.button-prev',
    },
    breakpoints: {
      992: {
        spaceBetween: 16, // Smaller spacing for wider viewports
      },
    },
    speed: 600, // Smooth transition speed
  });
  console.log(swiper); // Should log the Swiper instance
  console.log(document.querySelector('.button-next')); // Should log the button element
  console.log(document.querySelector('.button-prev')); // Should log the button element

  document.querySelector('.button-next').addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    // Prevent navigation if the next slide is hidden
    const isNextHidden = swiper.slides[swiper.activeIndex + 1]?.classList.contains('op0');
    if (isNextHidden || swiper.isEnd) {
      console.log('Cannot navigate to hidden or non-existent slides');
      return; // Do nothing if the next slide is hidden or it's already the last slide
    }

    console.log('Next button clicked');
    swiper.slideNext();
  });

  document.querySelector('.button-prev').addEventListener('click', function (e) {
    e.stopPropagation();
    e.preventDefault();

    // Prevent navigation if the current slide is the first
    if (swiper.isBeginning) {
      console.log('Cannot navigate before the first slide');
      return; // Do nothing if already at the first slide
    }

    console.log('Previous button clicked');
    swiper.slidePrev();
  });

  // Force update after a slight delay
  setTimeout(() => swiper.update(), 100);
  swiper.on('update', () => {
    console.log('Swiper updated');
    console.log(swiper.slides); // Verify slides are properly recognized
  });

  // Initialize GSAP ScrollTrigger plugin (if needed for other animations)
  gsap.registerPlugin(ScrollTrigger);

  // Removed ScrollTrigger logic for slide navigation and pinning
  // Optional: Keep ScrollTrigger for animating other elements
};



window.lastStep = function() {

}







// !!!!!!!!! Keep this Alpine init at the end !!!!!!!!!
window.Webflow ||= [];
window.Webflow.push(() => {
  initAlpine();
  scrollToTop();
  setupNavbarHover();
  setupGsapHeadings();
  animateGsapElements();

});
